/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { workspacesGenerate } from "../../funcs/workspacesGenerate.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations.PostApiWorkspaceServiceV1WorkspacesRequestBody$inboundSchema,
};

export const tool$workspacesGenerate: ToolDefinition<typeof args> = {
  name: "workspaces_generate",
  description: `Create workspace`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await workspacesGenerate(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
